/**
 * The symbols used to identify different environments.
 */
export enum EnvironmentName {
  /**
   * Local environment, typically used for development on a personal machine.
   * Default URL: `http://localhost:4200`
   */
  Local = 'local',

  /**
   * Development environment, used for testing new features and changes.
   * Default URL: `https://dev.brainkey.ai/`
   */
  Dev = 'dev',

  /**
   * Staging environment, used for pre-production testing.
   * Default URL: `https://staging.brainkey.ai/`
   */
  Staging = 'staging',

  /**
   * Production environment, used for the live application.
   * Default URL: `https://www.brainkey.ai/`
   */
  Prod = 'prod',
}
